import { IntlShape } from "react-intl";

import { BadgeColor } from "components/v2/Badge/Badge";

export type EmailNotificationPaymentLocation = {
  id: number;
  location_name: string;
};

export type EmailNotificationCondition = "origin_country" | "cost_center";

export type EmailNotification = {
  id?: number;
  name: string;
  event: string;
  scope: "company_wide" | "payment_locations";
  payment_locations: EmailNotificationPaymentLocation[];
  conditions: EmailNotificationCondition[];
  is_active: boolean;
};

export const EMAIL_NOTIFICATION_CONDITION_COLORS: Record<EmailNotificationCondition, BadgeColor> = {
  origin_country: "brand",
  cost_center: "indigo",
};

export const formatEmailNotificationEvent = (intl: IntlShape, event: string): string => {
  if (event === "shipment_booked") {
    return intl.formatMessage({
      id: "settings.emailNotifications.event.shipmentBooked",
      defaultMessage: "Shipment is booked",
    });
  }
  return event;
};

export const formatEmailNotificationScope = (
  intl: IntlShape,
  scope: EmailNotification["scope"],
  paymentLocations: EmailNotificationPaymentLocation[],
): string => {
  if (scope === "company_wide") {
    return intl.formatMessage({
      id: "settings.emailNotifications.companyWide",
      defaultMessage: "Company-wide",
    });
  }
  if (paymentLocations.length === 1) {
    return paymentLocations[0].location_name;
  }
  return intl.formatMessage(
    {
      id: "settings.emailNotifications.paymentLocationCount",
      defaultMessage: "{count} payment locations",
    },
    { count: paymentLocations.length },
  );
};

export const formatEmailNotificationCondition = (intl: IntlShape, condition: string): string => {
  if (condition === "origin_country") {
    return intl.formatMessage({
      id: "settings.emailNotifications.originCountry",
      defaultMessage: "Origin country",
    });
  }
  if (condition === "cost_center") {
    return intl.formatMessage({
      id: "settings.emailNotifications.costCenter",
      defaultMessage: "Cost center",
    });
  }
  return condition;
};
